import { useState, useEffect, useCallback, useRef } from 'react';

const useStaggeredCards = () => {
  const [visibleCards, setVisibleCards] = useState(new Set());
  const observerRef = useRef(null);
  const elementsRef = useRef([]);

  useEffect(() => {
    observerRef.current = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const index = parseInt(entry.target.dataset.cardIndex);
            setVisibleCards(prev => new Set([...prev, index]));
          }
        });
      },
      { threshold: 0.1 }
    );

    elementsRef.current.forEach(el => {
      if (el) observerRef.current.observe(el);
    });

    return () => observerRef.current?.disconnect();
  }, []);

  const registerCard = useCallback((el, index) => {
    if (el) {
      el.dataset.cardIndex = index;
      elementsRef.current[index] = el;
      if (observerRef.current) observerRef.current.observe(el);
    }
  }, []);

  const getCardStyle = useCallback((index) => {
    const isVisible = visibleCards.has(index);
    return {
      opacity: isVisible ? 1 : 0,
      transform: isVisible ? 'translateY(0)' : 'translateY(40px)',
      transition: `opacity 0.5s ease ${index * 80}ms, transform 0.5s ease ${index * 80}ms`,
    };
  }, [visibleCards]);

  return { registerCard, getCardStyle };
};

export default useStaggeredCards;
